export const CONCLUSION_APPROVAL_VIEW_LABELS = {
  CANCEL: 'Cancel',
  SAVE: 'Save',
  SAVING: 'Saving...',
  SAVE_ERROR_TITLE: 'Failed to save report',
  SAVE_ERROR_DESCRIPTION: 'Please try again.',
} as const

export const CONCLUSION_TAB_LABELS = {
  CONCLUSION_STEP: 'Conclusion',
  APPROVAL_STEP: 'Approval',
} as const

export const CONCLUSION_DRAFT_VIEW_LABELS = {
  SUBMIT_FOR_APPROVAL: 'Submit for approval',
  NEXT: 'Next',
  SUBMIT_ERROR_TITLE: 'Failed to submit for approval',
  SUBMIT_ERROR_DESCRIPTION: 'Please try again or contact support.',
  CONTROLS: 'Controls:',
} as const
